class USCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-us-carousel-track]');
    this.previousButton = this.querySelector('[data-us-carousel-previous]');
    this.nextButton = this.querySelector('[data-us-carousel-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons(), { passive: true });
    this.updateButtons();
  }

  move(direction) {
    const card = this.track.querySelector('[data-us-carousel-card]');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
    const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
  }
}

if (!customElements.get('us-carousel')) {
  customElements.define('us-carousel', USCarousel);
}

function initUSAnnouncements(root = document) {
  root.querySelectorAll('[data-us-announcements]').forEach((region) => {
    if (region.dataset.initialized === 'true') return;
    const items = [...region.querySelectorAll('[data-us-announcement]')];
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    region.dataset.initialized = 'true';
    let active = 0;
    const speed = Number(region.dataset.speed) || 6000;
    window.setInterval(() => {
      items[active].classList.remove('is-active');
      active = (active + 1) % items.length;
      items[active].classList.add('is-active');
    }, speed);
  });
}

function initUSPopup(root = document) {
  const popup = root.querySelector('[data-us-popup]');
  if (!popup || popup.dataset.initialized === 'true' || typeof popup.showModal !== 'function') return;
  popup.dataset.initialized = 'true';
  const storageKey = 'unfiltered-saints-popup-dismissed';
  let dismissedAt = 0;
  const rememberDismissal = () => {
    try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (error) { /* Storage may be unavailable. */ }
  };
  try { dismissedAt = Number(window.localStorage.getItem(storageKey) || 0); } catch (error) { /* Storage may be unavailable. */ }
  const hiddenFor = Number(popup.dataset.days || 7) * 86400000;
  const formSuccess = popup.querySelector('[role="status"]');

  if (formSuccess) {
    rememberDismissal();
    return;
  }

  if (!dismissedAt || Date.now() - dismissedAt > hiddenFor) {
    window.setTimeout(() => {
      if (!popup.open && document.visibilityState === 'visible') popup.showModal();
    }, Number(popup.dataset.delay) || 12000);
  }

  popup.querySelector('[data-us-popup-close]')?.addEventListener('click', () => {
    rememberDismissal();
    popup.close();
  });
  popup.addEventListener('click', (event) => {
    if (event.target === popup) {
      rememberDismissal();
      popup.close();
    }
  });
}

function initUSMenus(root = document) {
  root.querySelectorAll('.us-shop-menu').forEach((menu) => {
    if (menu.dataset.initialized === 'true') return;
    menu.dataset.initialized = 'true';
    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
}

function initUSTheme(root = document) {
  initUSAnnouncements(root);
  initUSPopup(root);
  initUSMenus(root);
}

initUSTheme();

document.addEventListener('shopify:section:load', (event) => initUSTheme(event.target));
